import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import ScrollToTop from "../common/scroll/ScrollToTop";
import NotFoundPage from "../pages/error/NotFoundPage";
import DashboardPage from "../pages/home/DashboardPage";
import RequestPointsPage from "../pages/requests/RequestPointsPage";
import { MyRequestsPage, RequestArchivePage, SubmitRequestPage } from "../pages/requests/index";
import RequestLetterPage from "../pages/requests/overview/letter/RequestLetterPage";
import RequestSupplementPage from "../pages/requests/overview/supplement/RequestSupplementPage";
import { cleanJoin } from "../utils/stringUtil";
import RequestVotingPage from "../pages/requests/RequestVotingPage";
import VoteResults from "../pages/requests/elections/newVoting/VoteResults";
import RequestUserDataPage from "../pages/requests/RequestUserDataPage";
import VotingPage from "../pages/requests/elections/newVoting/VotingPage";

function Page({ user }) {
  const location = useLocation();

  return (
    <main
      className={cleanJoin(
        "content mb-0 ",
        location.pathname === user.applicationConfiguration.dashboardUri ? "ml-4 mr-4 mt-4" : ""
      )}
    >
      <Switch>
        <Route exact path={user.applicationConfiguration.dashboardUri}>
          <DashboardPage />
        </Route>
        <Route exact path="/requests">
          <MyRequestsPage user={user} />
        </Route>
        <Route exact path={`/requests/:id/submissions/:uid/supplement`}>
          <RequestSupplementPage />
        </Route>
        <Route exact path={`/requests/:id/submissions/:uid/letter`}>
          <RequestLetterPage />
        </Route>
        <Route exact path="/submitRequest">
          <SubmitRequestPage user={user} />
        </Route>
        <Route exact path="/archive">
          <RequestArchivePage />
        </Route>
        <Route exact path="/points">
          <RequestPointsPage />
        </Route>
        <Route exact path="/profile">
          <RequestUserDataPage />
        </Route>
        <Route exact path="/elections">
          <RequestVotingPage />
        </Route>
        <Route exact path="/voting/:id">
          <VotingPage />
        </Route>
        <Route exact path="/voting/:id/results">
          <VoteResults />
        </Route>

        <Route path="*">
          <NotFoundPage />
        </Route>
      </Switch>
      <ScrollToTop />
    </main>
  );
}

export default Page;
